import React, { useContext, useState, useMemo, createContext } from "react";
import {
    FilterDataProviderProps,
    FilterDataContextData,
    IFilter,
    IModalFilterOptions,
} from "../interfaces/IFilterDataContext";
import { initialFilter, initialModalFilterOptions } from "./initialFilterData";

export const FilterDataContext = createContext<FilterDataContextData>(
    {} as FilterDataContextData
);

export function FilterDataProvider({ children }: FilterDataProviderProps) {
    const [filterGenerate, setFilterGenerate] =
        useState<IFilter>(initialFilter);

    const [filterPage, setFilterPage] = useState<IFilter>(initialFilter);

    const [modalFilterOptions, setModalFilterOptions] =
        useState<IModalFilterOptions>(initialModalFilterOptions);

    const handleResetFilter = (isFilterPage: boolean): void => {
        if (isFilterPage) {
            setFilterPage(initialFilter);
        } else {
            setFilterGenerate(initialFilter);
        }
        setModalFilterOptions(initialModalFilterOptions);
    };

    const setModalDataFilter = (isGenerate: boolean, filter: IFilter): void => {
        if (isGenerate) {
            setFilterGenerate(filter);
        } else {
            setFilterPage(filter);
        }
    };

    const contextValue = useMemo(
        () => ({
            filterGenerate,
            setFilterGenerate,
            filterPage,
            setFilterPage,
            handleResetFilter,
            modalFilterOptions,
            setModalFilterOptions,
            setModalDataFilter,
        }),
        [filterGenerate, filterPage, modalFilterOptions]
    );

    return (
        <FilterDataContext.Provider value={contextValue}>
            {children}
        </FilterDataContext.Provider>
    );
}

export function useFilterData() {
    return useContext(FilterDataContext);
}
